import * as React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Label,
  Flex,
  Box,
  Input,
  Text
} from '@urbaninfrastructure/react-ui-kit';
import { Warning } from '@urbaninfrastructure/react-icons';
import styled from 'styled-components';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: React.ReactNode;
  description?: React.ReactNode;
  errorText?: string;
}

const InputFieldDescription = styled(Text)``;
InputFieldDescription.defaultProps = {
  typoStyle: 'xxs',
  color: 'neutral.5',
  mt: 1
};

export const InputField = ({
  id,
  label,
  errorText,
  description,
  ...props
}: InputFieldProps) => {
  const descriptionId = `${id}-desc`;
  const errorId = `${id}-error`;
  let ariaDescribedBy = description ? descriptionId : undefined;
  if (errorText) {
    ariaDescribedBy = errorId;
  }
  return (
    <Box mb="xs" position="relative">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        aria-describedby={ariaDescribedBy}
        aria-invalid={errorText ? true : false}
        borderColor={errorText ? 'state.error' : undefined}
        {...props}
      />

      {description && (
        <InputFieldDescription id={descriptionId}>
          {description}
        </InputFieldDescription>
      )}
      <AnimatePresence>
        {errorText && (
          <motion.div
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Flex id={errorId} alignItems="center" color="state.error" mt={1}>
              <Warning size={16} />
              <Text ml={1} typoStyle="xxs">
                {errorText}
              </Text>
            </Flex>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};
